<template lang="pug">
#admin_container.container-small
  h1#container_title 보도자료 글수정
  .container_wr
    #s41.sub
      .inner
        .total_board_view_wrap.board_table 
          table.guest_table
            colgroup
              col(width='120px')
              col(width='160px')
              col(width='120px')
              col
            tbody
              tr
                th
                  label 분류
                td(colspan='1')
                  select.s_tit(v-model='args.category' v-if="nation == 'kr'")
                    option(value='') 선택하세요
                    option(value='2') 공지사항
                    option(value='1') 보도자료
                  select.s_tit(v-model='args.category' v-else)
                    option(value='') 선택하세요
                    option(value='12') 공지사항
                    option(value='11') 보도자료
                th
                  label 언어
                td(colspan='1')
                  select.s_tit(v-model='nation' disabled)
                    option(value='kr') 한국어
                    option(value='en') 영어
              tr
                th 제목
                td(colspan='3')
                  input#wr_subject.frm_input.full_input.required(v-model='args.title')
              tr.wr_tr
                td(colspan='4')
                  .write_div
                    tiptap(:options='options' ref="tiptap")
          table.option_table
            colgroup
              col(width='120px')
              col(width='160px')
              col(width='120px')
            tbody
              tr
                th 링크 #1
                td(colspan='3')
                  input.frm_input.full_input(v-model="args.fir_link")
              tr
                th 링크 #2
                td(colspan='3')
                  input.frm_input.full_input(v-model="args.sec_link")
          .board_btn
            button#btn_submit(@click='submit()') 확인
            button#btn_list(@click='$_goTo({name: "news-admin"})') 목록

</template>

<script>
import { mapGetters } from 'vuex';
import Tiptap from './Tiptap.vue';
export default {
  components: {
    Tiptap,
  },
  data() {
    return {
      options: {
        content: '',
        editable: true,
        supportImage: true,
      },
      args: {
        category: '',
      },
      nation: '',
      con: '',
      fileObj: {},
      param: '',
    };
  },
  computed: {
    ...mapGetters(['userAccToken']),
  },
  methods: {
    async getData() {
      await this.$_admin_get('admin/news/detail/edit', {
        id: this.param,
        nation: this.nation,
      }).then(res => {
        let data = res.data.res[0];
        this.options.content = data.content;
        this.args = data;
      });
    },
    submit() {
      if (this.args.category == '') {
        alert('분류를 선택해주세요.');
        return;
      } else if (this.args.title == '') {
        alert('제목을 작성해주세요.');
        return;
      } else if (this.options.content == '') {
        alert('내용을 작성해주세요.');
        return;
      }

      this.fileObj = this.$refs.tiptap.fileObj;
      const formData = new FormData();
      let res = this.options.content;

      if (Object.keys(this.fileObj).length !== 0) {
        // NOTE: 에디터에서 새로운 사진을 추가했을 때

        let titleRegex = /<img[^>]*title=[\"']?([^>\"']+)[\"']?[^>]*>/g;
        let srcRegex = /<img[^>]*src=[\"']?([^>\"']+)[\"']?[^>]*>/g;

        let title = [];
        let src = [];

        while (titleRegex.test(this.options.content)) {
          title.push(RegExp.$1);
        }
        while (srcRegex.test(this.options.content)) {
          src.push(RegExp.$1);
        }

        if (title.length > 3) {
          alert('사진은 최대 3장까지 올릴 수 있습니다.');
          return;
        }

        for (let i = 0; i < title.length; i++) {
          if (src[i].substr(0, 4) == 'blob') {
            res = res.replace(src[i], '_' + title[i]);
          }
        }

        title.forEach((e, i) => {
          if (Object.keys(this.fileObj).includes(e)) {
            let imgFile = this.fileObj[e];
            if (imgFile) {
              const blob = new Blob([imgFile], { type: imgFile.type });
              formData.append('files', blob, imgFile.name);
            }
          }
        });
      }

      formData.append('nation', this.nation);
      formData.append('CATEGORY', this.args.category);
      formData.append('TITLE', this.args.title);
      formData.append('CONTENT', res);
      formData.append('IDX', this.param);
      formData.append('FIRST_LINK', this.args.fir_link);
      formData.append('SECOND_LINK', this.args.sec_link);

      this.$_upLoad('put', 'admin/news/edit', formData).then(res => {
        if (res) {
          alert('게시글이 수정되었습니다.');
          this.$_goTo({
            name: 'news-detail-admin',
            params: this.param,
            query: { nation: this.nation },
          });
        } else {
          alert('등록에 실패하였습니다.');
          return;
        }
      });
    },
  },
  created() {},
  beforeMount() {
    this.param = this.$route.params.id;
    this.nation = this.$route.query.nation;
    this.args.category = this.$route.query.cat;
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
@import '../../../assets/css/news_board.css';
@import '../../../assets/css/contact-fir.css';
@import '../../../assets/css/contact-sec.css';
.editor__content .ProseMirror * {
  margin: 0 !important;
}
.editor__content .write_div .ProseMirror img {
  margin: 0 auto !important;
}
.ProseMirror {
  margin: 15px;
}
.wr_tr {
  width: 100%;
  height: 450px;
}
.wr_tr td {
  padding: 0 15px;
}
.write_div {
  width: 100%;
  margin: 0;
}
.add_file {
  vertical-align: middle;
}
.fir_span {
  display: inline-block;
  vertical-align: middle;
}
.sec_span {
  display: inline-block;
}
.add_img {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-right: 1px;
}
.minus_img {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
}
.sub_right {
  padding: 120px 0;
}
@media (max-width: 1024px) {
  .sub_right {
    padding: 100px 0;
  }
}
@media (max-width: 768px) {
  .sub_right {
    padding: 80px 0;
  }
}
.board_btn {
  text-align: center;
  padding: 20px;
}
.board_btn button#btn_submit {
  padding: 10px 25px;
  background: #333;
  color: #fff;
  border: 1px solid #ddd;
  line-height: 100%;
  cursor: pointer;
}
.board_btn button#btn_list {
  padding: 10px 25px;
  background: #fff;
  color: #333;
  border: 1px solid #ddd;
  line-height: 100%;
  cursor: pointer;
}
.editor .editor__content .ProseMirror img {
  margin: 0 auto !important;
}
.sub:first-child {
  padding-top: 30px;
}
</style>
